export const calculatePercentageChange = (originalNumber, newNumber) => {
  const difference = newNumber - originalNumber
  return (difference / originalNumber) * 100
}
